import { format } from 'date-fns'
import { massageDate } from '@unreserved-frontend-v2/utils/date-formatters'
import { ResidentialPropertyForSaleListing } from '@unreserved-frontend-v2/api/generated/graphql/types'

export function getDateSoldForUI(listing: ResidentialPropertyForSaleListing | undefined | null, displayFormat: string) {
  return listing?.dateSold ? format(massageDate(listing.dateSold), displayFormat) : ''
}
